import { render, staticRenderFns } from "./Releases.vue?vue&type=template&id=4cf46e26&"
import script from "./Releases.vue?vue&type=script&lang=js&"
export * from "./Releases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports